// 待提交的状态值
export const WAIT_SUBMIT_STATUS = '1';
// 待审核的状态值
export const WAIT_AUDIT_STATUS = '2';
// 已审核的状态值
export const OVER_AUDIT_STATUS = '3';
// Tabs的options
export const TABS_OPTIONS = [
  {
    key: WAIT_SUBMIT_STATUS,
    label: '待提交',
  },
  {
    key: WAIT_AUDIT_STATUS,
    label: '待审核',
  },
  {
    key: OVER_AUDIT_STATUS,
    label: '已审核',
  },
];
// 审核状态的字段名
export const REVIEW_STATUS = 'reviewStatus';
// 审核人id字段
export const REVIEWER = 'reviewer';
// 创建人id字段 （供应商才需要）
export const OPERATOR = 'operator';
// 表单栅格响应式数值
export const SPAN = { xs: 24, sm: 24, md: 24, lg: 12, xl: 8, xxl: 6 };
